var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useMemo, useState } from "react";
import { getAuditLogsAPI, } from "../../../resources/helper/auditLogs";
import { showErrorToast } from "../../../fnx/showError";
/**
 * Pads a number to 2 digits.
 */
var pad2 = function (n) { return ("0" + n).slice(-2); };
/**
 * Formats an ISO timestamp into "DD/MM/YYYY HH:mm" for the log line prefix.
 */
var formatLogTimestamp = function (iso) {
    if (!iso)
        return "";
    var d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return "";
    return ("".concat(pad2(d.getDate()), "/").concat(pad2(d.getMonth() + 1), "/").concat(d.getFullYear(), " ") +
        "".concat(pad2(d.getHours()), ":").concat(pad2(d.getMinutes())));
};
/**
 * Extracts a human-readable error message from outputMetadata when present.
 */
var extractError = function (entry) {
    var _a, _b;
    var out = entry.outputMetadata;
    if (!out)
        return undefined;
    if (typeof out.error === "string")
        return out.error;
    if ((_b = (_a = out.data) === null || _a === void 0 ? void 0 : _a.paymentResponseMetadata) === null || _b === void 0 ? void 0 : _b.error) {
        return String(out.data.paymentResponseMetadata.error);
    }
    return undefined;
};
/**
 * Extracts the user name from the entry's userData when present.
 */
var extractUserName = function (entry) {
    var _a;
    var name = (_a = entry.userData) === null || _a === void 0 ? void 0 : _a.name;
    return typeof name === "string" ? name.trim() : "";
};
/**
 * Builds a single bitácora line from a raw audit log entry.
 * Example: "01/01/2026 00:00 - Carlos Monzon - Asegurado titular (Cotizaciones)"
 */
export var formatAuditLogEntry = function (entry) {
    var _a;
    var ts = formatLogTimestamp(entry.createdAt);
    var userName = extractUserName(entry);
    var userLabel = userName ? " - ".concat(userName) : "";
    var message = ((_a = entry.message) === null || _a === void 0 ? void 0 : _a.trim()) || entry.action || "Evento";
    var moduleLabel = entry.module ? " (".concat(entry.module, ")") : "";
    var error = extractError(entry);
    var tail = error ? " - ".concat(error) : "";
    return "".concat(ts).concat(userLabel, " - ").concat(message).concat(moduleLabel).concat(tail).trim();
};
export var useAuditLogs = function (_a) {
    var _b = _a.page, page = _b === void 0 ? 0 : _b, _c = _a.size, size = _c === void 0 ? 50 : _c, _d = _a.orderDir, orderDir = _d === void 0 ? "DESC" : _d, hasError = _a.hasError, _e = _a.enable, enable = _e === void 0 ? true : _e, quoteId = _a.quoteId, setSeeToast = _a.setSeeToast, t = _a.t;
    var _f = useState([]), rawLogs = _f[0], setRawLogs = _f[1];
    var _g = useState(false), loadingGetAuditLogs = _g[0], setLoadingGetAuditLogs = _g[1];
    var fetchAuditLogs = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var baseParams, merged, _a, quoteRes, policyRes, quoteData, policyData, response, error_1, errorForToast;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!enable)
                        return [2 /*return*/];
                    setLoadingGetAuditLogs(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    baseParams = { page: page, size: size, orderDir: orderDir };
                    if (typeof hasError === "boolean")
                        baseParams.hasError = hasError;
                    merged = [];
                    if (!quoteId) return [3 /*break*/, 3];
                    return [4 /*yield*/, Promise.all([
                            getAuditLogsAPI(__assign(__assign({}, baseParams), { targetedObjectId: quoteId, targetedObjectType: "QUOTE" })),
                            getAuditLogsAPI(__assign(__assign({}, baseParams), { targetedObjectId: quoteId, targetedObjectType: "POLICY" })),
                        ])];
                case 2:
                    _a = _b.sent(), quoteRes = _a[0], policyRes = _a[1];
                    quoteData = Array.isArray(quoteRes === null || quoteRes === void 0 ? void 0 : quoteRes.data) ? quoteRes.data : [];
                    policyData = Array.isArray(policyRes === null || policyRes === void 0 ? void 0 : policyRes.data) ? policyRes.data : [];
                    merged = __spreadArray(__spreadArray([], quoteData, true), policyData, true).sort(function (a, b) {
                        var tA = new Date(a.createdAt).getTime();
                        var tB = new Date(b.createdAt).getTime();
                        return orderDir === "ASC" ? tA - tB : tB - tA;
                    });
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, getAuditLogsAPI(baseParams)];
                case 4:
                    response = _b.sent();
                    merged = Array.isArray(response === null || response === void 0 ? void 0 : response.data) ? response.data : [];
                    _b.label = 5;
                case 5:
                    setRawLogs(merged);
                    return [3 /*break*/, 8];
                case 6:
                    error_1 = _b.sent();
                    errorForToast = {
                        errors: (error_1 === null || error_1 === void 0 ? void 0 : error_1.errors) || [],
                        message: (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) ||
                            "No se pudo cargar la bitácora. Intente nuevamente.",
                    };
                    showErrorToast(errorForToast, setSeeToast, t, true);
                    return [3 /*break*/, 8];
                case 7:
                    setLoadingGetAuditLogs(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); }, [enable, page, size, orderDir, hasError, quoteId, setSeeToast, t]);
    useEffect(function () {
        fetchAuditLogs();
    }, [fetchAuditLogs]);
    var logEntries = useMemo(function () { return rawLogs.map(formatAuditLogEntry); }, [rawLogs]);
    return {
        rawLogs: rawLogs,
        logEntries: logEntries,
        loadingGetAuditLogs: loadingGetAuditLogs,
        refetchAuditLogs: fetchAuditLogs,
    };
};
